
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class BacCountdown extends Vue {
  countDownDate: Date = new Date()
  now = 0
  distance = 0
  days = 0
  hours = 0
  minutes = 0
  seconds = 0

  mounted () {
    this.setCounter()
    setInterval(this.setCounter, 1000)
  }

  setCounter () {
    this.countDownDate = new Date('2025-10-01T18:25:00.000Z')
    this.now = new Date().getTime()
    this.distance = (this.countDownDate as any) - this.now
    if (this.distance < 0) {
      this.distance = 0
    }
    this.days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
    this.hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    this.minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
    this.seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
  }
}
